import { Pipe, PipeTransform } from '@angular/core';
import { ShareViewModel } from '../services/share.service';

export interface ShareIconInfo {
  icon: string;
  color: string;
  tooltip: string;
}

@Pipe({
  name: 'shareIcon'
})
export class ShareIconPipe implements PipeTransform {
  transform(shareInfo: ShareViewModel, itemName: string = 'item'): ShareIconInfo {
    // Default to private if no share info is provided
    if (!shareInfo) {
      return {
        icon: 'lock',
        color: 'red',
        tooltip: `This ${itemName} is not shared (Private)`
      };
    }

    // Public sharing
    if (shareInfo.isPublic) {
      return {
        icon: 'public',
        color: 'green',
        tooltip: `This ${itemName} is public - Accessible to everyone`
      };
    }

    // Specific users
    if (shareInfo.sharedWithUserId && typeof shareInfo.sharedWithUserId === 'string' && shareInfo.sharedWithUserId.length > 0) {
      return {
        icon: 'people',
        color: 'blue',
        tooltip: `This ${itemName} is shared with specific users`
      };
    }

    // Specific roles
    if (shareInfo.sharedWithRoleId && typeof shareInfo.sharedWithRoleId === 'string' && shareInfo.sharedWithRoleId.length > 0) {
      return {
        icon: 'assignment_ind',
        color: 'orange',
        tooltip: `This ${itemName} is shared with specific roles`
      };
    }

    // Default (private)
    return {
      icon: 'lock',
      color: 'red',
      tooltip: `This ${itemName} is not shared (Private)`
    };
  }
}
